import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectSearchDateRange, selectSearchTypes } from '@store/global/selectors';
import { setSearchDateRange, setSearchTypes } from '@store/global/slice';
import { CheckboxGroup } from 'components/checkbox/CheckboxGroup';
import { Checkbox } from 'components/checkbox/Checkbox';
import { SearchTypes, isSearchTypes } from '@api/shipping-data/types/SearchTypes';
import { DateRange } from '@project-types/DateRange';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';



export const SearchSettings = () => {

	const searchDateRange = useSelector(selectSearchDateRange);
	const searchTypes = useSelector(selectSearchTypes);

	const dispatch = useDispatch();
	const updateSearchDateRange = (dateRange: DateRange) => dispatch(setSearchDateRange(dateRange));
	const updateSearchTypes = (values: SearchTypes[] | null) => dispatch(setSearchTypes(values));

	return (
		<div className='popover-search-settings'>

			<DateRangePicker
				label='Vyhledat v období:'
				value={
					searchDateRange
					? { start: parseDate(searchDateRange.from), end: parseDate(searchDateRange.to) }
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateSearchDateRange({
							from: rangeValue.start.toString(),
							to: rangeValue.end.toString(),
						});
					}
				}}
			/>

			<CheckboxGroup
				label='Vyhledat mezi:'
				value={searchTypes && searchTypes.length === 1 && searchTypes.includes(SearchTypes.searchAll)
					? [ SearchTypes.searchOrders, SearchTypes.searchCustomers, SearchTypes.searchShipments ]
					: searchTypes !== null
					? searchTypes
					: []
				}
				onChange={(values) => {
					if (!values || values.length === 0) {
						updateSearchTypes(null);
						return;
					}
					if (!values.every(x => isSearchTypes(x))) return;

					values.length === 3
					&& values.includes(SearchTypes.searchOrders)
					&& values.includes(SearchTypes.searchCustomers)
					&& values.includes(SearchTypes.searchShipments)
					? updateSearchTypes([ SearchTypes.searchAll ])
					: updateSearchTypes(values);
				}}>
					<Checkbox value={SearchTypes.searchOrders}>Objednávky</Checkbox>
					<Checkbox value={SearchTypes.searchCustomers}>Zákazníky</Checkbox>
					<Checkbox value={SearchTypes.searchShipments}>Shipmenty</Checkbox>
			</CheckboxGroup>

		</div>
	);
}